const JBP_PLANNING = 'jbp-planning'

export const splitPlanningRowTranslation = {
  splits: `${JBP_PLANNING}-show-contr-trans-switcher`,
  distributorSplits: `${JBP_PLANNING}-show-all-splits-switcher`,
}
